// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ski-about h2.ski-status{border-bottom:1px solid #dcdee0;padding:1rem 0}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/student-knowledge-inventory-about.vue"],"names":[],"mappings":"AAIC,yBACC,+BAAA,CACA,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
